const SAO_PAULO = 'America/Sao_Paulo';

const yearIn = (date: Date): string => new Intl.DateTimeFormat('en-US', {
  year: 'numeric', timeZone: SAO_PAULO,
}).format(date);

/**
 * The day a video aired, in Brasília time, short: "26 out" / "Oct 26". The
 * year is added only when it isn't the current one. Lives start around 20:00
 * Brasília, already the next day in UTC, so the zone matters.
 */
export function formatAiredDay(
  iso: string | null | undefined,
  locale: string,
  now: Date = new Date(),
): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;

  const english = locale.startsWith('en');
  const parts = new Intl.DateTimeFormat(english ? 'en-US' : 'pt-BR', {
    day: 'numeric', month: 'short', year: 'numeric', timeZone: SAO_PAULO,
  }).formatToParts(date);
  const get = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? '';
  const day = get('day');
  const month = get('month').replace('.', '');
  const year = yearIn(date) === yearIn(now) ? null : get('year');

  if (english) return year ? `${month} ${day}, ${year}` : `${month} ${day}`;
  return year ? `${day} ${month} ${year}` : `${day} ${month}`;
}
